import { render, staticRenderFns } from "./SegmentEdit.vue?vue&type=template&id=296133f2&scoped=true&"
import script from "./SegmentEdit.vue?vue&type=script&lang=js&"
export * from "./SegmentEdit.vue?vue&type=script&lang=js&"
import style0 from "./SegmentEdit.vue?vue&type=style&index=0&id=296133f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "296133f2",
  null
  
)

export default component.exports